// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2Cgku","validationTips":"StatementDescriptor_validationTips__2eJzk"};